import React, {useContext} from 'react';
import * as R from 'ramda';
import {SystemConfigCtx} from '@/contexts';
import {blank} from '@/util';
import {useTranslation} from 'react-i18next';
import {Card, CardBody, Row, Col, Button} from 'reactstrap';
import styles from '@/b2b/index.module.css';
import Form, {Text, Select, RadioGroup, DatePicker} from '@/Form';

import {NewBusinessCtx} from '@/b2b/contexts';
import {initialFields} from '@/b2b/pages/NewBusiness/state';
import {
  buildRadioOptions,
  buildSelectOptions,
} from '@/components/Form/formHelper';

const SearchBox = () => {
  const {t: tr} = useTranslation();
  const {siteCode} = useContext(SystemConfigCtx);
  const [{fields, queryParams}, dispatch] = useContext(NewBusinessCtx);

  const formData = {
    ...fields,
    manager: queryParams.manager,
    selectedProducerId: queryParams.selectedProducerId,
  };

  const handleReset = () => {
    dispatch({type: 'changeFields', payload: initialFields});
  };

  const setFormData = callback => {
    dispatch({type: 'changeFields', payload: callback()});
  };

  const handleSubmit = event => {
    event.preventDefault();
    dispatch({type: 'submit'});
  };

  const stageOptionList = R.compose(list => list[siteCode])(
    tr('selection:stage_options_by_site')
  );

  if (blank(siteCode)) {
    return null;
  }

  return (
    <Form
      className={styles.search_box}
      stateHook={[formData, setFormData]}
      onSubmit={handleSubmit}
    >
      <Card>
        <CardBody className={styles.search_box_body}>
          <Row form>
            <Col md={10}>
              <Text name='manager' label={tr('consultant')} readOnly />
            </Col>
            <Col md={2}>
              <RadioGroup name='includedTeam' label={tr('included_team')}>
                {buildRadioOptions(
                  tr('selection:included_team'),
                  formData.includedTeam
                )}
              </RadioGroup>
            </Col>
          </Row>
          <Row form>
            <Col md={10}>
              <Text name='keywords' label={tr('nb:keywords')} />
            </Col>
          </Row>
          <Row form>
            <Col md={6}>
              {siteCode !== 'absg' && (
                <>
                  <label>{tr('stage')}</label>
                  <Row>
                    <Col md='auto' className='px-0'>
                      <RadioGroup name='stage' label=''>
                        {buildRadioOptions(
                          tr('selection:stage_type'),
                          formData.stage
                        )}
                      </RadioGroup>
                    </Col>
                    <Col md='3' className='pl-0'>
                      <Select
                        name='stageOptions'
                        disabled={formData.stage !== 'select'}
                      >
                        {buildSelectOptions(stageOptionList)}
                      </Select>
                    </Col>
                  </Row>
                </>
              )}
            </Col>
            <Col md={6} className='pl-4'>
              <label>{tr('search_rec_date')}</label>
              <Row>
                <Col md={4} className='pr-1'>
                  <DatePicker name='receivedFrom' />
                </Col>
                <Col md={4} className='pr-1'>
                  <DatePicker name='receivedTo' />
                </Col>
              </Row>
            </Col>
          </Row>
          <Row form>
            <Col md={10} />
            <Col md='1 text-right'>
              <Button size='sm' type='submit'>
                {tr('search')}
              </Button>
            </Col>
            <Col md={1}>
              <Button size='sm' onClick={handleReset} color='secondary'>
                {tr('reset')}
              </Button>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </Form>
  );
};

export default SearchBox;
